// extracted by mini-css-extract-plugin
export default {"weixinPublicContainer":"WeixinPublic_weixinPublicContainer__wFUHS","header":"WeixinPublic_header__RZVns","scanAuth":"WeixinPublic_scanAuth__fKSW7"};